import { folderPermissionsSavingFailed } from '../strings.locstring.json';
import { cantCompleteRequestText } from 'owa-locstrings/lib/strings/cantcompleterequesttext.locstring.json';
import loc, { format } from 'owa-localize';
import { orchestrator } from 'satcheljs';
import {
    setFolderPermissionsLoader,
    showHideFolderPermissionDialog,
} from '../actions/internalActions';
import {
    getFolderTable,
    updateFolderPermissionsFailed,
    updateFolderPermissionsSuccess,
} from 'owa-folders';
import { getStore } from '../store/store';

import { confirm } from 'owa-confirm-dialog';
const styles = require('../components/FolderPermissionsDialog.scss');

/**
 * This orchestrator watches updateFolderPermissionsSuccess action from owa-folders.
 * It will fire action to close the folder permission dialog.
 */
export const updateFolderPermissionsSuccessOrchestrator = orchestrator(
    updateFolderPermissionsSuccess,
    () => {
        const { folderId, showFolderPermissionsDialog } = getStore();
        // Orchestrator should not permform any task, if permission dialog is not open.
        if (!showFolderPermissionsDialog) {
            return;
        }
        showHideFolderPermissionDialog(folderId, false /* Should show */);
    }
);

/**
 * This orchestrator watches updateFolderPermissionsFailed action from owa-folders.
 * It will show error dialog, which on being closed, will fire action to hide the loader.
 */
export const updateFolderPermissionsFailedOrchestrator = orchestrator(
    updateFolderPermissionsFailed,
    async () => {
        const { folderId, showFolderPermissionsDialog } = getStore();
        // Orchestrator should not permform any task, if permission dialog is not open.
        if (!showFolderPermissionsDialog) {
            return;
        }
        const { DisplayName } = getFolderTable().get(folderId);

        // Show error dialog.
        const messageTitle = loc(cantCompleteRequestText);
        const messageSubText = format(loc(folderPermissionsSavingFailed), DisplayName);
        // Loader will be hidden once user closes the error dialog.
        await confirm(messageTitle, messageSubText, false, {
            hideCancelButton: true,
            containerClassName: styles.folderPermissionUpdateErrorDialog,
        });
        setFolderPermissionsLoader(false);
    }
);
